// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon_icon__1U10O","icon__canvas":"Icon_icon__canvas__345KT"};